import { render } from "./section_2.vue?vue&type=template&id=887d60d4"
import script from "./section_2.vue?vue&type=script&lang=js"
export * from "./section_2.vue?vue&type=script&lang=js"

import "./section_2.vue?vue&type=style&index=0&id=887d60d4&lang=css"
script.render = render

export default script